import { theme } from '@global-engineering-shared/gweb-global-theme';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  title: {
    height: '24px',
    fontSize: '16px',
    marginBottom: theme.spacing(2),
  },
});

export default useStyles;
